const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphic1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 386.46 67.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "372.22 0 363.95 14.3 378.25 14.3 386.46 0",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.25 49.58 386.46 35.28 372.22 35.28 363.95 49.58 378.25 49.58",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.54,
    y: 17.64,
    width: 36.76,
    height: 14.3,
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.78,
    y: 35.28,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.49,
    y: 35.28,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.04 67.22 298.25 52.93 284.01 52.93 275.74 67.22 290.04 67.22",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "266.36 0 258.1 14.3 272.4 14.3 280.61 0",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.4 67.22 280.61 52.93 266.36 52.93 258.1 67.22 272.4 67.22",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.76 67.22 262.97 52.93 248.72 52.93 240.46 67.22 254.76 67.22",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "231.08 0 222.82 14.3 237.12 14.3 245.33 0",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.12 31.94 245.33 17.64 231.08 17.64 222.82 31.94 237.12 31.94",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.13 49.58 309.37 35.28 167.02 35.28 158.78 49.58 301.13 49.58",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.69,
    y: 52.93,
    width: 36.76,
    height: 14.3,
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "213.44 0 205.18 14.3 219.47 14.3 227.69 0",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.49 31.94 291.73 17.64 149.37 17.64 141.14 31.94 283.49 31.94",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.05,
    y: 52.93,
    width: 36.76,
    height: 14.3,
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "195.8 0 187.53 14.3 201.83 14.3 210.04 0",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.83 31.94 210.04 17.64 195.8 17.64 187.53 31.94 201.83 31.94",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.85 67.22 274.08 52.93 131.73 52.93 123.49 67.22 265.85 67.22",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.19 67.22 192.4 52.93 178.15 52.93 169.89 67.22 184.19 67.22",
    style: {
      fill: "#7c79f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.55 31.94 174.76 17.64 160.51 17.64 152.25 31.94 166.55 31.94",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.48,
    y: 17.64,
    width: 36.76,
    height: 14.3,
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.71,
    y: 52.93,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "121.07 0 121.07 14.3 135.37 14.3 135.37 0",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.62 67.22 121.83 52.93 107.59 52.93 99.32 67.22 113.62 67.22",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.99 49.58 168.23 35.28 25.88 35.28 17.64 49.58 159.99 49.58",
    style: {
      fill: "#da410f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.35 67.22 150.59 52.93 8.24 52.93 0 67.22 142.35 67.22",
    style: {
      fill: "#da410f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic1);
export default __webpack_public_path__ + "static/media/Graphic1.ec76cbfb3acf4ae30f97a2563b8b82db.svg";
export { ForwardRef as ReactComponent };